import React from 'react';
import PropTypes from 'prop-types';
import {browserHistory} from 'react-router';
import {RepProfileTab} from '@store/coaching-plans';
import Button from '@material-ui/core/Button';
import isTodayOrInThePast from 'utils/datetime/isTodayOrInThePast';
import CoachingReview from 'records/CoachingReview';
import './AgendaMeetingLink.styl';
import connectToStores from 'alt-utils/lib/connectToStores';
import InProgressReviewStore from 'stores/coaching/InProgressReviewStore';
import AuthStore from 'stores/AuthStore';
import {reviewPath} from 'components/dashboard/reviewPath';

/**
 * Link to allow coaches to start a coaching review even though the recipient still has
 * outstanding items, or to continue such a review that is in progress.
 *
 * The link is only visible when the review is scheduled to start today or earlier (i.e.,
 * today is the day of the review or the review is overdue) OR when the review is in progress.
 */
@connectToStores
export default class AgendaMeetingLink extends React.PureComponent {
  static propTypes = {
    review: PropTypes.instanceOf(CoachingReview).isRequired,
  };

  static getStores() {
    return [AuthStore, InProgressReviewStore];
  }

  static getPropsFromStores({review}) {
    const sessionUser = AuthStore.getState().user;
    if (!review) {
      return {sessionUser};
    }
    const {inProgressReviews} = InProgressReviewStore.getState();
    return {
      sessionUser,
      inProgress: !!inProgressReviews.get(review.id + ''), // keys are strings.
    };
  }

  render() {
    const {inProgress, review, sessionUser} = this.props;
    const canStartReview = review && isTodayOrInThePast(review.scheduleAt);
    if (!canStartReview && !inProgress) {
      return null;
    }
    const label = inProgress ? 'Continue Meeting' : 'Start Meeting Anyway';
    return (
      <div className="agenda-meeting-link">
        <Button
          variant="text"
          fullWidth
          onClick={() => {
            browserHistory.push({
              pathname: reviewPath(sessionUser),
              query: {
                tab: RepProfileTab.COACHING_PLANS,
                teamId: review.rep.teamId,
                userId: review.rep.id,
                planId: review.planId,
                reviewId: review.id,
                autoStartReview: true,
              },
            });
          }}>
          {label}
        </Button>
      </div>
    );
  }
}
